module.exports = __webpack_public_path__ + "static/media/message.410d26dc.svg";